import CryptoJS from "crypto-js";
import axios from "axios";
import { encryptionKey, middleware, gristMiddleware } from "../store/constants";
import { api_base } from "../store/constants";
import { fetchJiraToken } from "../store/fetchJiraToken";
import store from "@/store";
import moment from "moment/moment";
import { getToken } from "@/plugins/tothemoonAuth";

const iv = CryptoJS.lib.WordArray.random(16);

export function filterAcceptDepartments(rawData, includeAdmin = false) {
  let data = rawData.records || rawData;

  const departmentOrder = ["ADMIN", "AE", "DEV", "BA", "GRAPHIC", "QA", "CEO","ACC"];

  const departments = {
    DEV: [],
    BA: [],
    GRAPHIC: [],
    QA: [],
    AE: [],
    ADMIN: [],
    CEO: [],
    ACC: [],

  };

  for (const row of data) {
    const n = row?.fields ?? row;
    if (!n?.department) continue;
    if (n.status?.toLowerCase() === "inactive") continue;
    if (departments[n.department] !== undefined) {
      if (n.department === "ADMIN" && !includeAdmin) continue;
      departments[n.department].push(n.user || n.name);
    }
  }

  function compareDepartments(a, b) {
    return departmentOrder.indexOf(a) - departmentOrder.indexOf(b);
  }

  const result = departmentOrder.reduce((acc, dept) => {
    return acc.concat(departments[dept].sort(compareDepartments));
  }, []);

  return result;
}
export function encrypt(text, iv) {
  const ivHex = iv.toString(CryptoJS.enc.Hex);
  const key = CryptoJS.enc.Hex.parse(encryptionKey);
  const ivCryptoJS = CryptoJS.enc.Hex.parse(ivHex);
  const encrypted = CryptoJS.AES.encrypt(text, key, { iv: ivCryptoJS });

  return {
    encryptedData: encrypted.toString(),
    iv: ivHex,
  };
}
export function decrypt(encryptedData, iv) {
  const keyBytes = CryptoJS.enc.Hex.parse(encryptionKey);
  const ivBytes = CryptoJS.enc.Hex.parse(iv);

  const decryptedBytes = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedData) },
    keyBytes,
    { iv: ivBytes },
  );
  return decryptedBytes.toString(CryptoJS.enc.Utf8);
}

export async function gristApiFire(body) {
  const { encryptedData, iv: ivHex } = encrypt(JSON.stringify(body), iv);

  store.commit("general/setLoading", true);

  try {
    const res = await axios.post(gristMiddleware, {
      encryptedData: encryptedData,
      iv: ivHex,
    });

    const decryptedData = decrypt(res.data.encryptedData, res.data.iv);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.log("error :", error);
    throw error;
  } finally {
    store.commit("general/setLoading", false);
  }
}

export async function ApiFire(url, body = null, method = "GET") {
  try {
    store.commit("general/setLoading", true);

    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    // ส่งแผนกของ user ไปกับทุก request เสมอ ให้ backend เช็คสิทธิ์ฝั่งการเงินได้เอง
    // (ไม่ใช่แค่พึ่ง UI ฝั่ง frontend ปิดปุ่ม) — ดู routes/middleware/financeAuth.js (tracking_notify)
    const employeeDepartment = store.state.employee?.employeeDepartment;
    if (employeeDepartment) {
      headers["x-employee-department"] = employeeDepartment;
    }

    let res;

    if (method === "GET") {
      res = await axios.get(url, { headers });
    } else if (method === "POST") {
      res = await axios.post(url, body, { headers });
    } else if (method === "PATCH") {
      res = await axios.patch(url, body, { headers });
    } else if (method === "DELETE") {
      res = await axios.delete(url, { headers });
    }

    return res.data;
  } catch (error) {
    console.error("ApiFire error:", error);
    throw error;
  } finally {
    store.commit("general/setLoading", false);
  }
}

export async function requestAndResponse(body) {
  let { encryptedData, iv: ivHex } = encrypt(JSON.stringify(body), iv);
  store.commit("general/setLoading", true);
  let res = await axios.post(middleware, {
    encryptedData: encryptedData,
    iv: ivHex,
  });
  store.commit("general/setLoading", false);
  let decryptedData = decrypt(res.data.encryptedData, res.data.iv);
  return JSON.parse(decryptedData);
}

export async function requestAndResponseOverview(formData) {
  store.commit("general/setLoading", true);
  try {
    const res = await axios.post(`${api_base}toTheMoonNotify`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    store.commit("general/setLoading", false);
    return res.data;
  } catch (error) {
    console.error("err", error);
  }
}

export async function requestAndResponseJira(payload) {
  console.log("payload:", payload);
  let { encryptedData, iv: ivHex } = encrypt(JSON.stringify(payload), iv);

  const url = `${api_base}jiraApi`;

  try {
    store.commit("general/setLoading", true);

    const res = await axios.post(url, {
      payload: encryptedData,
      iv: ivHex,
    });

    const decryptedData = decrypt(res.data.payload, res.data.iv);

    const result = JSON.parse(decryptedData);

    return result;
  } catch (err) {
    console.log("err :", err);
    throw err;
  } finally {
    store.commit("general/setLoading", false);
  }
}

export function unixToDate(unix) {
  const date = new Date(unix * 1000);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function formatDateGrist(date) {
  console.log("date", date);

  const formatDate = moment(date, "D/M/YYYY").format("YYYY-MM-DD");
  console.log("formate date ", formatDate);

  return formatDate;
}
